export default {
    places: [],
};